import styled from "styled-components";

const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radii.card};
  padding: ${({ theme, $padding }) =>
    $padding !== undefined ? theme.spacing($padding) : theme.spacing(4)};
`;

function CardComponent({ padding, children, ...props }) {
  return (
    <Card $padding={padding} {...props}>
      {children}
    </Card>
  );
}

export default CardComponent;
